import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import useStyles from "./FmHeaderSlider.style";

interface FmHeaderSliderProps {
  stepNumber: number;
}

export default function FmHeaderSlider(props: FmHeaderSliderProps) {
  const classes = useStyles();
  const { stepNumber } = props;

  return (
    <div className={classes.container}>
      <Box width={"94vw"}>
        <Slider
          value={stepNumber + 1}
          aria-label="Default"
          valueLabelDisplay="auto"
          disableSwap={false}
          max={5}
          sx={{
            ".MuiSlider-thumb": { display: "none" },
            ".MuiSlider-rail": { background: "#fff" },
          }}
        />
      </Box>
    </div>
  );
}
